// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAiIdin3dGQuXVrzZe6c_hnH8V7Swo2TRs",
  authDomain: "rocket-digital-infra.firebaseapp.com",
  projectId: "rocket-digital-infra",
  storageBucket: "rocket-digital-infra.appspot.com",
  messagingSenderId: "793101618749",
  appId: "1:793101618749:web:31ae56cd08114213af6454",
  measurementId: "G-MV9KDVZNRS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app)

let messaging = null;
try{

  messaging = getMessaging(app);
  
  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    // Customize notification handling here if needed
  });
}catch(e){
  console.log(e)
}

// O `getDatabase(app)` saiu daqui na F2 (plano-firebase-para-aws.md:2.1): este
// modulo e' importado estaticamente pelo push (F4), entao manter `firebase/database`
// nele obrigaria o SDK do RTDB a entrar no bundle em qualquer modo. Quem conecta
// agora e' services/rtdbCliente.js, carregado por import dinamico.
export { app, messaging, getToken, onMessage, analytics };
